var map = {
	"./404.png": "3dfc",
	"./ad/ad-1.png": "dd22",
	"./ad/ad-2.jpg": "3e65",
	"./ad/ad-3.png": "e37a",
	"./ads/demo_ad.png": "dd17",
	"./ads/one_ad.png": "6b16",
	"./ads/three_ad.png": "bf34",
	"./ads/two_ad.jpg": "36b4",
	"./arrow-2.svg": "e957",
	"./arrow.svg": "27e4",
	"./author.png": "ab09",
	"./author1.png": "faa6",
	"./business-1.jpg": "fb12",
	"./business-2.jpg": "9f8f",
	"./business-3.jpg": "994c",
	"./business-4.jpg": "904d",
	"./business-post/business-post-1.jpg": "e8f1",
	"./business-post/business-post-2.jpg": "50d7",
	"./business-post/business-post-3.jpg": "f94a",
	"./business-post/business-post-4.jpg": "69a5",
	"./business-post/business-post-5.jpg": "636d",
	"./business-post/business-post-6.jpg": "73bb",
	"./button/reg20.png": "68c3",
	"./button/reg21.png": "fafe",
	"./button/reg22.png": "1e72",
	"./categories-1.jpg": "855c",
	"./categories-2.jpg": "7a7c",
	"./categories-3.jpg": "f393",
	"./categories-4.jpg": "0d6a",
	"./categories-5.jpg": "f3dd",
	"./categories-6.jpg": "c45a",
	"./comments-1.png": "deb0",
	"./comments-2.png": "b0ec",
	"./comments-3.png": "b481",
	"./comments-4.png": "7d12",
	"./default_avatar.png": "8247",
	"./empty.jpg": "e8b2",
	"./entertainment-1.jpg": "f5a9",
	"./entertainment-2.jpg": "ebbd",
	"./entertainment-3.jpg": "550f",
	"./entertainment-4.jpg": "a3ab",
	"./entertainment-dark-1.jpg": "0d05",
	"./entertainment-dark-2.jpg": "8060",
	"./entertainment-dark-3.jpg": "34dc",
	"./entertainment-dark-4.jpg": "e0a3",
	"./entertainment-dark-5.jpg": "2605",
	"./entertainment-dark-6.jpg": "008d",
	"./entertainment-dark-7.jpg": "31a6",
	"./fabicon.png": "65ac",
	"./feature-1.jpg": "092d",
	"./feature-2.jpg": "59c6",
	"./feature-3.jpg": "e74d",
	"./feature-4.jpg": "6025",
	"./feature-dark-1.jpg": "4133",
	"./feature-dark-2.jpg": "ad39",
	"./feature-dark-3.jpg": "5892",
	"./feature-dark-4.jpg": "ae9f",
	"./feature/feature-1.png": "f8aa",
	"./feature/feature-2.png": "8332",
	"./feature/feature-3.png": "d234",
	"./feature/feature-4.png": "537d",
	"./feature/feature-5.png": "c56b",
	"./feature/feature-6.png": "5860",
	"./feature/feature-7.png": "3b89",
	"./feature/feature-8.png": "fa37",
	"./feature/feature-news-1.jpg": "9cfa",
	"./feature/feature-news-2.jpg": "9ad7",
	"./feature/feature-news-3.jpg": "42c0",
	"./finance/finance-1.jpg": "1f1e",
	"./finance/finance-2.jpg": "4ece",
	"./finance/finance-3.jpg": "3f39",
	"./finance/finance-4.jpg": "b4ae",
	"./flag/flag-1.png": "6d15",
	"./flag/flag-2.png": "6577",
	"./flag/flag-3.png": "7a81",
	"./flag/flag-4.png": "b63d",
	"./flag/flag-5.png": "07a5",
	"./gallery-1.jpg": "9c51",
	"./gallery-2.jpg": "b072",
	"./gallery-3.jpg": "bec3",
	"./gallery-4.jpg": "b320",
	"./gallery-5.jpg": "832d",
	"./gallery-post-2.jpg": "4f1f",
	"./gallery-post-dark.jpg": "a3cc",
	"./gallery-post.jpg": "e8cc",
	"./gallery-post/1.png": "9fb5",
	"./gallery-post/2.png": "8338",
	"./gallery-post/3.png": "1510",
	"./gallery-post/4.png": "e198",
	"./gallery-post/5.png": "c737",
	"./gallery-post/item-1.jpg": "a58d",
	"./gallery-post/item-2.jpg": "c6b8",
	"./gallery-post/item-3.jpg": "59d0",
	"./gallery-post/item-4.jpg": "cf99",
	"./gallery-post/item-5.jpg": "2e32",
	"./gallery-post/item-6.jpg": "3e7f",
	"./gallery-post/item-7.jpg": "6058",
	"./gallery-post/item-dark-1.jpg": "ac21",
	"./gallery-post/item-dark-2.jpg": "fa8f",
	"./gallery-post/item-dark-3.jpg": "3f0f",
	"./gallery-post/item-dark-4.jpg": "3216",
	"./gallery-post/item-dark-5.jpg": "b9a4",
	"./gallery-post/item-dark-6.jpg": "9235",
	"./gallery-post/item-dark-7.jpg": "936a",
	"./hero-bg.jpg": "7da3",
	"./international-1.jpg": "aef2",
	"./international-2.jpg": "5662",
	"./international-post-thumb.jpg": "86a1",
	"./international-post/1.jpg": "e96c",
	"./international-post/2.jpg": "4ef0",
	"./international-post/3.jpg": "6958",
	"./international-post/4.jpg": "1152",
	"./international-post/5.jpg": "3d0f",
	"./kf.png": "b4b1",
	"./latest-news-1.png": "81f7",
	"./latest-news-2.png": "4a32",
	"./latest-news-3.png": "e760",
	"./loading1.gif": "64f0",
	"./logo-2.png": "898d",
	"./logo-3.png": "2879",
	"./logo-4.png": "451a",
	"./logo.png": "9d64",
	"./logo_bak.png": "7989",
	"./logo_text.png": "4b7f",
	"./mags/mag-1.jpg": "d097",
	"./mags/mag-2.jpg": "3060",
	"./mags/mag-3.jpg": "fad0",
	"./most-post/most-1.jpg": "db8e",
	"./most-post/most-2.jpg": "a788",
	"./most-post/most-3.jpg": "d8cc",
	"./most-post/most-4.jpg": "3ee2",
	"./most-post/most-5.jpg": "d888",
	"./most-post/most-6.jpg": "aaf1",
	"./opinion-post-thumb.jpg": "12ff",
	"./opinion/1.jpg": "4dab",
	"./opinion/2.jpg": "68f9",
	"./opinion/3.jpg": "2731",
	"./page/header.jpg": "054c",
	"./page/header_bg.png": "603a",
	"./page/tab.png": "1ae7",
	"./page/tab_bg.png": "5e4d",
	"./play-post-1.jpg": "db57",
	"./play-post-2.jpg": "e0cd",
	"./play-post-dark-1.jpg": "86f5",
	"./populer/populer-post-1.jpg": "68ed",
	"./populer/populer-post-2.jpg": "d4e6",
	"./populer/populer-post-3.jpg": "f492",
	"./populer/populer-post-4.jpg": "d46d",
	"./populer/populer-post-5.jpg": "cb24",
	"./post-1.jpg": "f69b",
	"./post-2.jpg": "93f9",
	"./post-3.jpg": "0d18",
	"./post-dark-1.jpg": "b659",
	"./post-dark-2.jpg": "f8cf",
	"./post-dark-3.jpg": "2016",
	"./post-layout.png": "1b77",
	"./post-news-thumb-1.png": "23ef",
	"./post-news-thumb-2.png": "b615",
	"./post-news/1.jpg": "0549",
	"./post-news/2.jpg": "44fe",
	"./post-news/3.jpg": "491e",
	"./post-news/4.jpg": "d37e",
	"./post-news/5.jpg": "4fb6",
	"./post-play-thumb.jpg": "dced",
	"./post-play.jpg": "77c2",
	"./post-quote.jpg": "4805",
	"./post-sports-1.jpg": "6927",
	"./post-thumb-2.png": "77ee",
	"./post-thumb-3.jpg": "36fd",
	"./post-thumb-4.png": "2338",
	"./post-thumb-5.png": "36a9",
	"./post-thumb-6.png": "f8cfd",
	"./post-thumb-7.png": "d8c8",
	"./quote-icon.png": "67b9",
	"./science-1.jpg": "f60e",
	"./science-2.jpg": "1fd2",
	"./science-3.jpg": "d9b7",
	"./science-4.jpg": "43bc",
	"./sports-news.jpg": "0026",
	"./sports/sports-1.jpg": "92d6",
	"./sports/sports-2.jpg": "acc1",
	"./sports/sports-3.jpg": "6798",
	"./sports/sports-4.jpg": "10e3",
	"./sports/sports-5.jpg": "0a2c",
	"./tab-post/1.png": "b366",
	"./tab-post/2.png": "42f8",
	"./tab-post/3.png": "1684",
	"./tab-post/4.png": "b33c",
	"./tab-post/5.png": "d945",
	"./technology-item-2.png": "bff8",
	"./temperature-icon-2.png": "1949",
	"./temperature-icon-3.svg": "bed4",
	"./temperature-icon.svg": "97e2",
	"./trending-business/1.jpg": "3fe3",
	"./trending-business/2.jpg": "9818",
	"./trending-business/3.jpg": "e20b",
	"./trending-business/4.jpg": "d2b2",
	"./trending-business/5.jpg": "cd00",
	"./trending-image-post-1.jpg": "dc0d",
	"./trending-image-post-2.jpg": "1acd",
	"./trending-image-thumb.jpg": "0e01",
	"./trending-news-1.jpg": "70b5",
	"./trending-news-2.jpg": "5511",
	"./trending-news-3.jpg": "c159",
	"./trending-news-dark-1.jpg": "a342",
	"./trending-news-dark-2.jpg": "fc86",
	"./trending-thumb.jpg": "3d0c",
	"./trending-thumb.png": "3891",
	"./video-items/1.png": "318d",
	"./video-items/2.png": "0102",
	"./video-items/3.png": "9748",
	"./video-items/4.png": "285f",
	"./video-items/5.png": "3961",
	"./video-items/6.png": "0922",
	"./video-play-thumb.jpg": "f45b",
	"./video-post-thumb-dark.jpg": "b4a1",
	"./video-post-thumb.jpg": "7dd9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";